import { ModelModal } from "./ModelModal";

export function ModelPage() {
    return <ModelModal />;
}
